/**
 * Home Page
 * Main storefront landing page with promotional sections
 */

'use client';

import styled from '@emotion/styled';
import { HeroSection } from '@/components/HeroSection';
import { CategorySection } from '@/components/organisms/CategorySection';
import { BestSellers } from '@/components/organisms/BestSellers';
import { WeeklyDeals } from '@/components/organisms/WeeklyDeals';
import { YoullAlsoLove } from '@/components/organisms/YoullAlsoLove';
import { SocialProof } from '@/components/organisms/SocialProof';

const Main = styled.main`
  width: 100%;
`;

export function HomePage() {
  return (
    <Main>
      <HeroSection />
      <CategorySection />
      <BestSellers />
      <WeeklyDeals />
      <YoullAlsoLove />
      <SocialProof />
    </Main>
  );
}
